// src/components/strumenti/DimensionamentoAlimentatore.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function DimensionamentoAlimentatore() {
  const [caricoMa, setCaricoMa] = useState("");
  const [capacitaAh, setCapacitaAh] = useState("");
  const [fattoreRicarica, setFattoreRicarica] = useState("0.1");

  const caricoA = (leggiNumero(caricoMa)||0)/1000;
  const Ah = leggiNumero(capacitaAh)||0;
  const fatt = leggiNumero(fattoreRicarica)||0.1;
  const correnteRicarica = Ah*fatt;
  const totaleNecessario = caricoA + correnteRicarica;
  // Margine di sicurezza indicativo del 20%, prassi comune per non lavorare al limite
  const consigliato = totaleNecessario*1.2;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Assorbimento totale carico (mA)</label>
          <input value={caricoMa} onChange={e=>setCaricoMa(e.target.value)} style={inp} placeholder="Es. 500"/>
        </div>
        <div>
          <label style={lbl}>Capacità batteria tampone (Ah)</label>
          <input value={capacitaAh} onChange={e=>setCapacitaAh(e.target.value)} style={inp} placeholder="Es. 7"/>
        </div>
      </div>
      <div style={{ marginBottom:16 }}>
        <label style={lbl}>Fattore corrente di ricarica (tipico 0.1 = C/10)</label>
        <input value={fattoreRicarica} onChange={e=>setFattoreRicarica(e.target.value)} style={inp}/>
      </div>

      <div style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:10, padding:"14px 16px" }}>
        <div style={{ display:"flex", justifyContent:"space-around", marginBottom:10, fontSize:11, color:"#6b7280" }}>
          <div style={{textAlign:"center"}}>
            <div>Carico</div>
            <div style={{fontWeight:700, color:"#374151", fontSize:14}}>{caricoA.toFixed(2)} A</div>
          </div>
          <div style={{textAlign:"center"}}>
            <div>Ricarica batteria</div>
            <div style={{fontWeight:700, color:"#374151", fontSize:14}}>{correnteRicarica.toFixed(2)} A</div>
          </div>
        </div>
        <div style={{ textAlign:"center", borderTop:"1px solid #fecaca", paddingTop:10 }}>
          <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:2 }}>Alimentatore consigliato (con margine 20%)</div>
          <div style={{ fontSize:24, fontWeight:800, color:"#dc2626" }}>
            {consigliato>0 ? consigliato.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"}
            <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>A</span>
          </div>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Stima indicativa — verificare sempre la corrente massima erogabile dichiarata dal produttore dell'alimentatore.
      </div>

      <button onClick={()=>{setCaricoMa("");setCapacitaAh("");setFattoreRicarica("0.1");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
